
// $("img.b-lazy").lazyload({
// 	effect : "fadeIn"
// });
  
$(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 3600 && !$('.back_to_top').hasClass('active') ) {
    $('.back_to_top').addClass('active').fadeIn();
  } else if( y < 3600 && $('.back_to_top').hasClass('active') ) {
    $('.back_to_top').removeClass('active').fadeOut();
  }
});
